import React from "react";
import MixpanelService from "./utils/MixpanelService";

const PopupMenu = ({ title, header, options, visible, top, left, right, bottom, width }) => {
  const style = {
    ...(top !== undefined && { top }),
    ...(left !== undefined && { left }),
    ...(right !== undefined && { right }),
    ...(bottom !== undefined && { bottom }),
    ...(width !== undefined && { width }),
  };

  const containerClass = `popup_menu__container${visible ? " popup_menu__container--visible" : ""}`;

  return (
    <div className={containerClass} style={style}>
      {header && <div className="popup_menu__header">{header}</div>}
      {title && <div className="popup_menu__title">{title}</div>}
      <div className="popup_menu__options-container">
        {options.map((option) => (
          <a
            href={option.url}
            className="popup_menu__option"
            onClick={() =>
              MixpanelService.track(
                option.mixpanelEventName,
                option.mixpanelSource ? { source: option.mixpanelSource } : {}
              )
            }
            key={option.name}
          >
            {option.icon && <span className="popup_menu__option__icon">{option.icon}</span>}
            {option.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default PopupMenu;
